module.exports = __webpack_public_path__ + "img/20240906142234.9dfe5d46.png";